<script setup lang="ts"></script>

<template>
  <footer class="text-center py-4 mt-auto custome-bg-color">
    <div class="container">
      <p class="mb-2">&copy; 2024 Abdurrakhman. All rights reserved.</p>
      <ul class="list-inline">
        <li class="list-inline-item mx-2">
          <a
            href="https://twitter.com"
            target="_blank"
            class="text-decoration-none"
          >
            Twitter
          </a>
        </li>
        <li class="list-inline-item mx-2">
          <a
            href="https://github.com/Abdu-user"
            target="_blank"
            class="text-decoration-none"
          >
            GitHub
          </a>
        </li>
        <li class="list-inline-item mx-2">
          <a
            href="https://github.com/Abdu-user/Web-Dev-Skills-"
            target="_blank"
            class="text-decoration-none"
          >
            GitHub-Repo
          </a>
        </li>
      </ul>
      <p class="mt-3 small">
        Built with ❤️ using
        <a
          href="https://vuejs.org/"
          class="text-info text-decoration-none"
          >Vue.js</a
        >
        and
        <a
          href="https://getbootstrap.com/"
          class="text-info text-decoration-none"
          >Bootstrap</a
        >.
      </p>
    </div>
  </footer>
</template>

<style scoped>
.custome-bg-color {
  background-color: rgba(128, 128, 128, 0.044);
}
</style>
